import { Component } from '@angular/core';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';

@Component({
  selector: 'app-problemas-tecnicos',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './problemas-tecnicos.component.html',
  styleUrl: './problemas-tecnicos.component.scss',
})
export class ProblemasTecnicosComponent {
  volverInicio(): void {
    window.location.href = "https://www.sura.co/";
  }
}
